<template>
  <div class="relative border border-dark-line rounded-xl overflow-hidden hover:border-accent">
    <div class="p-6">
      <img :src="category.photo.path" alt="" class="rounded-lg drop-shadow-[0_15px_15px_rgba(0,0,0,0.3)]">
      <h1 class="text-center mt-4">{{ category.name }}</h1>
      <div class="text-center mt-2 text-muted">
        <h3 class="mb-2">محصولات: {{ category.products_count }} عدد</h3>
        <VBadge :type="category.active ? 'success' : 'danger' ">
          {{ category.active ? 'فعال' : 'غیرفعال' }}
        </VBadge>
      </div>
    </div>

    <button class="flex justify-center py-4 w-full text-accent bg-accent/20" @click="editModal = true">
      ویرایش
      <PenIcon class="fill-accent mr-2"/>
    </button>
  </div>

  <ModalCategory
      :show="editModal"
      @click="editModal = !editModal"
      :category="category"
      @edited="edited"/>

</template>

<script>
import PenIcon from "@/components/Icons/PenIcon";
import VBadge from "@/components/General/VBadge";
import ModalCategory from "@/components/Modal/ModalCategory";

export default {
  name: "CategoryCard",
  components: {ModalCategory, VBadge, PenIcon},
  emits: ['edited'],
  props: ['category'],
  data() {
    return {
      editModal: false
    }
  },
  methods: {
    edited(category) {
      this.editModal = false
      this.$emit('edited', category)
    }
  }
}
</script>

<style scoped>

</style>